// @ts-check
// Persistencia local del intento cronometrado del panel "Autocorregir
// ejercicio" (editor de diagramas). Delega en el almacén genérico compartido
// (`state/attempt-persistence.js`) con un prefijo propio de esta feature, para
// no duplicar la lógica de `localStorage` en los tres editores. La API pública
// (`guardarIntento`/`leerIntento`/`limpiarIntento`/`PREFIJO_CLAVE`) se conserva.
import { crearPersistenciaIntento } from '../../state/attempt-persistence.js';

/** @typedef {import('../../state/attempt-persistence.js').IntentoPersistido} IntentoPersistido */

/** Prefijo de la clave; se completa con el `ejercicioId` (UUID). */
export const PREFIJO_CLAVE = 'progedu.diagram-editor.intento';

const almacen = crearPersistenciaIntento(PREFIJO_CLAVE);

export const { guardarIntento, leerIntento, limpiarIntento } = almacen;
